import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AddInstitutionComponent } from '../add-institution/add-institution.component';
import { UserService } from '../../services/user.service';
import {TokenStorageService} from "../../services/storage/token-storage.service";

interface PendingSelection {
  [key: string]: boolean;
}

@Component({
    selector: 'app-add-exchange',
    templateUrl: './add-exchange.component.html',
    styleUrls: ['./add-exchange.component.css'],
    standalone: false
})
export class AddExchangeComponent implements OnInit {
  Exchanges: any;
  instCode: any;
  exchangeList: any = [];
  addExchangeSubmitted: boolean = false;
  isSuccessful: boolean = false;
  errorMessage: string = '';
  loading: boolean = false;
  public pendingSelection: PendingSelection = Object.create(null);
  public selectedExchanges: any;
  public unselectedExchanges: any = [];
  public assignedExchanges: any = [];
  public alreadyassignedExchanges: any = [];
  noExchangeAssigned: boolean = false;
  filterText = '';
  exchangeNotAdded: boolean = false;
  institutionCode: string = 'GTN_API_0085';
  env:any;
  @Output() btnClicked = new EventEmitter<void>();


  @ViewChild(AddInstitutionComponent) addInstitutionComponent!: AddInstitutionComponent;

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.searchUnselected('')
    this.env = this.tokenStorage.getUserEnv();
  }
  getExchangeList(institutionCode:string) {
    this.loading = true
    this.institutionCode = institutionCode;
    this.userService.getUnassignedExchangeList(institutionCode).subscribe((data: any) => {
      if (data.status == 'SUCCESS') {
        this.exchangeList = data.list.map((item: any) => ({ ...item, selected: false }))
        this.unselectedExchanges = this.exchangeList.sort((a: any, b: any) =>
          a.exchangeCode > b.exchangeCode ? 1 : -1
        );
      } else {
        this.errorMessage = data.reason;
        this.toastr.error(
          this.errorMessage,
          'Error getting exchanges'
        );
      }
    });
    this.userService.getInstExchangesList(this.institutionCode, 'asia').subscribe((data: any) => {
      if (data.status == 'SUCCESS') {
        this.alreadyassignedExchanges = data.list.sort((a: any, b: any) =>
          a.exchangeCode > b.exchangeCode ? 1 : -1
        );
      } else {
        this.errorMessage = data.reason;
        this.toastr.error(
          this.errorMessage,
          'Error getting assigned exchanges'
        );
      }
    });
    this.loading = false
  }

  searchUnselected(event: any) {
    this.filterText = event;
    if (this.filterText == '') {
      this.unselectedExchanges = this.exchangeList;
    } else {
      this.unselectedExchanges = this.unselectedExchanges.filter((exchange: any) => {
        if (this.filterText != '') {
          return exchange.exchangeCode.toLowerCase().includes(this.filterText.toLowerCase());
        }
      });
    }
  }

  setInstExchangeList() {
    this.loading = true
    if (this.selectedExchanges == undefined || this.selectedExchanges.length == 0) {
      this.noExchangeAssigned = true;
      this.toastr.error('Please assign at least one exchange', 'Exchange Assign Error');
      this.loading = false
      return;
    }
    let exchangesToAssign = this.alreadyassignedExchanges.concat(this.selectedExchanges)
    let exchnageCodes = exchangesToAssign.map(function (item: any) {
      return item['exchangeCode'];
    });

    this.userService.instAssignExchange(this.institutionCode, exchnageCodes)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.btnClicked.emit();
            this.alreadyassignedExchanges = this.alreadyassignedExchanges.concat(this.selectedExchanges)
            this.alreadyassignedExchanges = this.alreadyassignedExchanges.sort((a: any, b: any) =>
              a.bankName > b.bankName ? 1 : -1
            );
            this.selectedExchanges = []
            this.toastr.success(data.reason, 'Success');
            // this.AssignBankList();
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to assign exchanges'
            );
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to assign exchanges'
          );
        },
      });
  }

  public addToSelectedExchanges(item?: any): void {
    var changeExchanges = (item) ? [item] : this.getPendingSelectionFromCollection(this.unselectedExchanges);
    this.pendingSelection = Object.create(null);
    this.unselectedExchanges = this.removeContactsFromCollection(this.unselectedExchanges, changeExchanges);
    this.selectedExchanges = this.selectedExchanges == undefined ? changeExchanges : changeExchanges.concat(this.selectedExchanges);
    this.selectedExchanges = this.selectedExchanges.map((item: any) => ({ ...item, selected: false }))
  }

  public removeFromSelectedExchanges(item?: any): void {
    var changeExchanges = (item) ? [item] : this.getPendingSelectionFromCollection(this.selectedExchanges);
    this.pendingSelection = Object.create(null);
    this.selectedExchanges = this.removeContactsFromCollection(this.selectedExchanges, changeExchanges);
    this.unselectedExchanges = changeExchanges.concat(this.unselectedExchanges).sort(this.sortContactOperator);
    this.unselectedExchanges = this.unselectedExchanges.map((item: any) => ({ ...item, selected: false }))
  }

  public togglePendingSelection(item: any): void {
    this.pendingSelection[item.exchangeCode] = !this.pendingSelection[item.exchangeCode];
    item.selected = !item.selected;
  }

  public addAllToSelectedExchanges(): void {
    this.selectedExchanges = []
    this.selectedExchanges.push(...this.exchangeList);
    this.unselectedExchanges = []
    this.selectedExchanges = this.selectedExchanges.map((item: any) => ({ ...item, selected: false }))
  }

  public addAllToUnselectedExchanges(): void {
    this.selectedExchanges == undefined ? this.selectedExchanges = [] : true
    this.unselectedExchanges.push(...this.selectedExchanges);
    this.selectedExchanges = []
    this.unselectedExchanges.sort(this.sortContactOperator)
    this.unselectedExchanges = this.unselectedExchanges.map((item: any) => ({ ...item, selected: false }))
  }

  private getPendingSelectionFromCollection(collection: any[]): any[] {
    var selectionFromCollection = collection.filter(
      (exchange) => {
        var id = exchange.exchangeCode
        return (exchange.exchangeCode in this.pendingSelection && this.pendingSelection[id] == true);
      }
    );
    return (selectionFromCollection);
  }

  private removeContactsFromCollection(
    collection: any[],
    contactsToRemove: any[]
  ): any[] {

    var collectionWithoutContacts = collection.filter(
      (contact) => {
        return (!contactsToRemove.includes(contact));
      }
    );

    return (collectionWithoutContacts);
  }

  private sortContactOperator(a: any, b: any): number {
    return (a.exchangeCode.localeCompare(b.exchangeCode));
  }


}
